export default __webpack_public_path__ + "app/images/9402c96f588afc2b01fcdea463bf6cfe.png";